import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import { formatValue, getColors, resolveKey } from '../chartUtils';
import type { ChartConfig } from '../chartUtils';
import { TOOLTIP_STYLE } from './constants';

export default function PieChartView({ data, config, fullscreen = false }: { data: Record<string, unknown>[]; config: ChartConfig; fullscreen?: boolean }) {
  const labelKey = resolveKey(config, 'label', data);
  const valueKey = resolveKey(config, 'value', data);
  const colors = getColors(config);

  const renderLabel = (props: { name?: string; percent?: number; value?: number }) => {
    const name = String(props.name || '');
    const percent = Number(props.percent || 0);
    const formattedVal = formatValue(props.value, config);
    const decimals = config.number_decimals ?? 0;
    return `${name} (${formattedVal}, ${(percent * 100).toFixed(decimals)}%)`;
  };

  return (
    <ResponsiveContainer width="100%" height={fullscreen ? '100%' : (config.height || 350)}>
      <PieChart>
        <Pie
          data={data}
          dataKey={valueKey}
          nameKey={labelKey}
          cx="50%"
          cy="50%"
          outerRadius={120}
          innerRadius={50}
          paddingAngle={2}
          label={config.show_values !== false ? (renderLabel as unknown as boolean) : false}
          labelLine={{ stroke: '#666' }}
        >
          {data.map((_, index) => (
            <Cell key={index} fill={colors[index % colors.length]} />
          ))}
        </Pie>
        <Tooltip {...TOOLTIP_STYLE} formatter={(value: unknown) => formatValue(value, config)} />
        {config.show_legend && <Legend wrapperStyle={{ fontSize: '12px', color: '#999' }} />}
      </PieChart>
    </ResponsiveContainer>
  );
}
